import { CollapseComponent } from '../libs/gin-tonic/components/collapse/component';
import { FormFieldComponent } from '../libs/gin-tonic/components/form-field/component';
import '../libs/gin-tonic/components/image';
import { SnackbarComponent } from '../libs/gin-tonic/components/snackbar/component';
import { factory } from '../libs/gin-tonic/helpers/compiler/index';
import { createDefaultComponent } from '../libs/gin-tonic/helpers/components/index';
import { loadBlazor } from './blazor/index';
import { DialogComponent } from './components/dialog/component';
import { Menu } from './components/menu/component';
import { NavVisibilityComponent } from './components/nav/component';
import { ProductSliderComponent } from './components/product-slider/sliders';
import { ProductStockComponent } from './components/product/component';
import { SelectComponent } from './components/select/component';
import { TabsComponent } from './components/tabs/component';
import { TooltipComponent } from './components/tooltip/index';
import './main.scss';

factory(
	[
		createDefaultComponent(Menu, 'js-menu'),
		CollapseComponent,
		TabsComponent,
		SelectComponent,
		DialogComponent,
		FormFieldComponent,
		TooltipComponent,
		SnackbarComponent,
		ProductSliderComponent,
		ProductStockComponent,
		NavVisibilityComponent
	],
	false
)(document.body);

loadBlazor();
